/* tslint:disable */
/* eslint-disable */
/**
 * Protech PCS API
 * API for Protech PCS ingestion process
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Customer,
  CustomerContact,
} from '../models';
import {
    CustomerFromJSON,
    CustomerToJSON,
    CustomerContactFromJSON,
    CustomerContactToJSON,
} from '../models';

export interface GetCustomerRequest {
    id: string;
    xPcsImpersonatedUser?: string;
}

export interface GetCustomerContactsRequest {
    id: string;
    xPcsImpersonatedUser?: string;
}

export interface GetCustomersRequest {
    all?: boolean;
    xPcsImpersonatedUser?: string;
}

/**
 * 
 */
export class CustomersApi extends runtime.BaseAPI {

    /**
     * Get a customer record
     * Get Customers
     */
    async getCustomerRaw(requestParameters: GetCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Customer>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getCustomer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xPcsImpersonatedUser !== undefined && requestParameters.xPcsImpersonatedUser !== null) {
            headerParameters['x-pcs-impersonated-user'] = String(requestParameters.xPcsImpersonatedUser);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-ms-client-principal"] = this.configuration.apiKey("x-ms-client-principal"); // api-security authentication
        }

        const response = await this.request({
            path: `/customer/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerFromJSON(jsonValue));
    }

    /**
     * Get a customer record
     * Get Customers
     */
    async getCustomer(requestParameters: GetCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Customer> {
        const response = await this.getCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get contact records for a customer
     * Get Customer Contacts
     */
    async getCustomerContactsRaw(requestParameters: GetCustomerContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CustomerContact>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getCustomerContacts.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xPcsImpersonatedUser !== undefined && requestParameters.xPcsImpersonatedUser !== null) {
            headerParameters['x-pcs-impersonated-user'] = String(requestParameters.xPcsImpersonatedUser);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-ms-client-principal"] = this.configuration.apiKey("x-ms-client-principal"); // api-security authentication
        }

        const response = await this.request({
            path: `/customer/{id}/contacts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CustomerContactFromJSON));
    }

    /**
     * Get contact records for a customer
     * Get Customer Contacts
     */
    async getCustomerContacts(requestParameters: GetCustomerContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CustomerContact>> {
        const response = await this.getCustomerContactsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a list of customer records
     * Get Customers
     */
    async getCustomersRaw(requestParameters: GetCustomersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Customer>>> {
        const queryParameters: any = {};

        if (requestParameters.all !== undefined) {
            queryParameters['all'] = requestParameters.all;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xPcsImpersonatedUser !== undefined && requestParameters.xPcsImpersonatedUser !== null) {
            headerParameters['x-pcs-impersonated-user'] = String(requestParameters.xPcsImpersonatedUser);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-ms-client-principal"] = this.configuration.apiKey("x-ms-client-principal"); // api-security authentication
        }

        const response = await this.request({
            path: `/customer`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CustomerFromJSON));
    }

    /**
     * Get a list of customer records
     * Get Customers
     */
    async getCustomers(requestParameters: GetCustomersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Customer>> {
        const response = await this.getCustomersRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
